import logo from './logo.svg';
import './App.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import AIBusinessArchitect from './components/market';
import Home from './components/Home';
import Navbar from './components/Navbar';
import New from './components/New';
import Existing from './components/existing';
import Test from './components/test';
import AnalysisForm from './components/AnalysisForm';
import CategoryPage from './components/CategoryPage';
import AnalysisOverview from './components/AnalysisOverview';
import CategoryPageNew from './components/CategoryPageNew';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import TermsOfService from './components/TermsOfService';
import CookiePolicy from './components/CookiePolicy';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './components/Login';
import Signup from './components/Signup';
import AuthCallback from './pages/AuthCallback';
import MyAnalyses from './pages/MyAnalyses';
import SavedAnalysisView from './pages/SavedAnalysisView';
import SavedCategoryView from './pages/SavedCategoryView';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    const handleScroll = () => {
      const backToTopBtn = document.querySelector('.back-to-top');
      if (backToTopBtn) {
        if (window.scrollY > 300) {
          backToTopBtn.classList.add('show');
        } else {
          backToTopBtn.classList.remove('show');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <main style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/new" element={<New />} />
              <Route path="/existing" element={<Existing />} />
              <Route path="/category/:categoryKey" element={<CategoryPage />} />
              <Route path="/category-new/:categoryKey" element={<CategoryPageNew />} />
              <Route path="/analysis" element={<AnalysisOverview />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path='/login' element={<Login />} />
              <Route path='/signup' element={<Signup />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/my-analyses" element={<MyAnalyses />} />
              <Route path="/saved/:id" element={<SavedAnalysisView />} />
              <Route path="/saved/:id/category/:categoryKey" element={<SavedCategoryView />} />
              <Route path="/saved/:id/category-new/:categoryKey" element={<SavedCategoryView />} />
              <Route path='/*' element={
                <div className='page-not-found'>
                  <div className="not-found-content">
                    <h1 className="not-found-code">404</h1>
                    <h3 className="not-found-title">Page Not Found</h3>
                    <p className="not-found-message">Oops! The page you're looking for doesn't exist or has been moved.</p>
                    <button className="not-found-btn" onClick={() => window.location.href = '/'}>
                      <i className="bi bi-house-door me-2"></i>
                      Back to Home
                    </button>
                  </div>
                </div>
              } />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;